import { addLocaleData } from 'react-intl';
import localeDataEn from 'react-intl/locale-data/en';
// import localeDataFr from 'react-intl/locale-data/fr';
import en from './en';
// import fr from './fr';

addLocaleData([
  ...localeDataEn,
  // ...localeDataFr,
]);

export const { defaultLanguage } = process.env;

export const messages = {
  en: en.messages,
  // fr: fr.messages,
};

export const supportedLanguages = Object.keys(messages);
